import React from 'react';
import { v4 as uuid } from 'uuid';
import useCreateElevesCustomFields from '@teetsh/app/src/queries/eleves/customFields/useCreateElevesCustomFields';
import { CustomFieldForm } from 'components/CustomFieldForm/CustomFieldForm';
import usePopoverContext from 'components/Popover/usePopoverContext';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';

interface Props {
  onClose: () => void;
  viewId?: string;
  onAdd?: (v) => void;
}

export function AddNewField(props: Props) {
  const { onClose } = props;
  const createEleveCustomField = useCreateElevesCustomFields();
  const classrooms = useClassrooms();
  return (
    <CustomFieldForm
      onSubmit={v => {
        const customFieldId = uuid();
        return createEleveCustomField({
          ...v,
          customFieldId,
          viewId: props.viewId,
        }).then(() => props.onAdd && props.onAdd(customFieldId));
      }}
      availableFieldTypes={[
        'text',
        'number',
        'phone',
        'multiselect',
        'filesAndMedia',
        'bool',
        'select',
      ]}
      cycles={[...new Set(classrooms.flatMap(c => c.cycle))]}
      onClose={onClose}
      initialValues={{
        name: '',
        type: 'text',
        options: [],
      }}
    />
  );
}

export function AddNewFieldPopoverWrapper(props: Props) {
  const { refs } = usePopoverContext();
  return (
    <AddNewField
      viewId={props.viewId}
      onClose={() => {
        (refs?.reference?.current as any).click();
      }}
    />
  );
}
